//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    snippet: {
      type: String,
      required: true,
    },
    link: {
      type: Object,
      required: true,
    },
  },
};
